import $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";

$(() => {
  if (typeof $.fn.autocomplete !== "function") return;

  $(".js-search-autocomplete").autocomplete({
    minLength: 2,
    source: function (request, response) {
      $.ajax({
        url: window.location.origin + window.location.pathname + "/autocomplete?q=" + request.term,
        dataType: "json",
        success: function (data) {
          response(
            $.map(data, function (item) {
              return {
                label: item,
                value: item,
              };
            })
          );
        },
      });
    },
  });
});
